import { render, staticRenderFns } from "./PlayerInfo.vue?vue&type=template&id=1ba41a96&scoped=true&"
import script from "./PlayerInfo.vue?vue&type=script&lang=js&"
export * from "./PlayerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba41a96",
  null
  
)

export default component.exports